import { createFileRoute } from "@tanstack/react-router";
import { InvitePage } from "../components/invite/invite-page";
import { confirmSession } from "../lib/session-gate";

/** The invitation page without its id: signing in or confirming an address returns here. */
export const Route = createFileRoute("/invite/")({
  beforeLoad: async () => {
    await confirmSession();
  },
  component: () => <InvitePage linkId={null} />,
});
